<div class="map-controls-legend-assembly-container container">
  <mtn-map-toolbar-button icon="question" color="blue" matTooltip="Map Legend" matTooltipPosition="right"
                          mtnAnalyticsEventTrigger [analyticsEventName]="AnalyticsEventType.CLICK_BUTTON"
                          [analyticsEventParameters]="{'target': 'map-legend-button'}"
                          (toolbarClick)="toggleSlide()"></mtn-map-toolbar-button>
  <div class="legend-container" [ngClass]="{hidden: isHidden, hiding: isHiding, showing: isShowing}" *ngIf="!isHidden">
    <div class="panel-connector"></div>
    <fa-icon class="clickable close-button color-muted" icon="times" size="xs" (click)="closeSlide()"></fa-icon>
    <div fxLayout="column" fxLayoutGap="5px">
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <img alt="Historical Marker" class="marker-image"
             src="https://res.cloudinary.com/mtn-retail-advisors/image/upload/c_scale,h_50/e_replace_color:a1b1c8:100:00ff00/e_outline:3,co_68478d/l_Map%20Markers:circle-solid,g_north,c_limit,h_26,y_9,e_replace_color:white:100:00ff00,fl_layer_apply/l_rs_icon,g_north,c_limit,h_11,y_16/v1571263789/Map%20Markers/marker.png"/>
        <strong>{{'HISTORICAL_STORE' | translate}}</strong>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <img alt="Active Store" class="marker-image"
             src="https://res.cloudinary.com/mtn-retail-advisors/image/upload/c_scale,h_50/e_replace_color:0f1b4d:100:00ff00/e_outline:3,co_863399/l_Map%20Markers:circle-solid,g_north,c_limit,h_26,y_9,e_replace_color:white:100:00ff00,fl_layer_apply/l_rs_icon,g_north,c_limit,h_11,y_16/v1571263789/Map%20Markers/marker.png"/>
        <strong>{{'ACTIVE_STORE' | translate}}</strong>
      </div>
      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
        <img alt="Future Store" class="marker-image"
             src="https://res.cloudinary.com/mtn-retail-advisors/image/upload/c_scale,h_50/e_replace_color:0033a1:100:00ff00/e_outline:3,co_3d7cc9/l_Map%20Markers:circle-solid,g_north,c_limit,h_26,y_9,e_replace_color:white:100:00ff00,fl_layer_apply/l_rs_icon,g_north,c_limit,h_11,y_16/v1571263789/Map%20Markers/marker.png"/>
        <strong>{{'FUTURE_STORE' | translate}}</strong>
      </div>
    </div>
    <hr/>
    <mat-checkbox class="preference-control" [formControl]="preferenceControl" color="primary"><small>{{'SHOW_LEGEND_ON_MAP_LOAD' | translate}}</small>
    </mat-checkbox>
  </div>
</div>
